import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'lodash';
import {genCompositeId} from 'module/Properties/util/PropertiesUtil';
import {PropertyID, PropID} from 'module/Properties/enum/PropID';
import {CompoundPropertyTO} from 'generated/JavaTO';
import {log} from 'common/log'

const PropertyModel = Backbone.Model.extend({
	idAttribute: "compositeId",
	initialize: function (attributes: PropertyID) {
		let key = attributes;
		this.set({compositeId: genCompositeId(key.object, key.attribute, key.type, key.subkrit)}, {silent: true})
	},
	url: function () {
		return "../json/prop?object=" + this.get('object') + "&attribute=" + this.get('attribute') + "&type=" + this.get("type") + (this.get('subkrit') ? "&subkrit=" + this.get('subkrit') : '')
	},
	parse: function (response: CompoundPropertyTO) {
		// object attribute merge to not loose defer, write not implemented.
		return {
			...this.attributes,
			value: response?.value,
		}
	},
	getValue: function () {
		return this.get('value')
	},
})

const PropertyCollection = Backbone.Collection.extend({
	model: PropertyModel,
	url: "../json/fetchProps", // not implemented yet
	/**
	 * @param id {PropID} attribute name
	 * @return {$.Deferred} resolving with an array of strings (value of Property)
	 * @deprecated use fetchProperties
	 */
	getProperty: function (id: PropertyKey) {
		let params = id;
		let model = this.findWhere(params);
		let defer = model && model.get('defer');
		if (defer && defer.state() !== 'pending') {
			//data present
			return model.getValue();
		} else if (defer) {
			//no data , already fetching
			return defer;
		} else {
			//no data, no running requests
			let defer = $.Deferred(); // for directly resolving with the value (unwrapping the model)
			model = new PropertyModel(params);
			model.set({defer: defer});
			this.add(model);
			model.fetch().done(function () {
				defer.resolve(model.getValue());
			}).fail(function () {
				defer.reject();
			});
			return defer;
		}
	},
	fetchProp: function (...propertyIDs: PropertyID[]) {
		let retDeferreds: JQueryPromise<string>[] = [];
		// check which are not fetched/already in collection
		let notFetched: typeof PropertyModel[] = [];
		const propIDs = _.uniqBy(propertyIDs, x => x + '')
		_.each(propIDs, (id) => {
			if (!_.includes(PropID, id)) {
				console.error("not a PropID, and therefore ignored: " + id);
				return;
			}
			let exists = this.findWhere(id);
			if (exists) {
				retDeferreds.push(exists.get("defer"));
			} else {
				let $_new = $.Deferred<string>();
				retDeferreds.push($_new);
				notFetched.push(
					new PropertyModel(
						_.assign({}, id, {defer: $_new}),
					),
				);
			}
		});
		if (!_.isEmpty(notFetched)) {
			// new data to fetch, add new ones
			let fetchedModels = this.add(notFetched);

			//prepare data for not fetched
			//todo also fetch single fetches in Collection, (add single and wait for
			let data = _.map(notFetched, function (m) {
				return m.omit(["defer", "compositeId"]);
			});
			let $_fetchAll = this.fetch({
				merge: true, // models are already added, only value added
				remove: false, // keep already fetched from other calls
				type: "POST",
				dataType: 'json',
				contentType: "application/json",
				data: JSON.stringify(data),
			});
			$_fetchAll.done(() => {
				_.each(fetchedModels, m => {
					m.get("defer").resolve(m.get('value'));
				});
			});
			$_fetchAll.fail(() => {
				_.each(fetchedModels, m => {
					m.get("defer").reject();
				});
			});
		}
		return $.when.apply(null, retDeferreds);
	},
});
const propertyCollection = new PropertyCollection();

export const fetchProperties = (...propIDs: PropertyID[]) => propertyCollection.fetchProp(...propIDs)

export default {
	/** deprecated */
	get: (id: PropertyID) => propertyCollection.getProperty(id),
	fetchProp: fetchProperties,
	ID: PropID,
	_inst: propertyCollection,
};